import { DatePicker, DatePickerProps } from '@heroui/react'
// import { parseDate, CalendarDate, CalendarDateTime, ZonedDateTime } from '@internationalized/date'
import { motion } from 'framer-motion'

export interface DateProps extends Omit<DatePickerProps, 'value' | 'onChange'> {
  label?: string
  classNameContainer?: string
  name?: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  errorMessage?: string
  isRequired?: boolean
}

const Date = ({
  label,
  classNameContainer,
  name,
  value,
  onChange,
  onBlur,
  errorMessage,
  isRequired = false,
  ...props
}: DateProps) => {
  // const handleDateChange = (date: CalendarDate | CalendarDateTime | ZonedDateTime | null) => {
  //   onChange?.(date ? date.toString() : '')
  // }

  return (
    <motion.div className={classNameContainer}>
      <DatePicker
        showMonthAndYearPickers
        className="h-full"
        errorMessage={errorMessage}
        isInvalid={Boolean(errorMessage)}
        isRequired={isRequired}
        label={label}
        labelPlacement="outside"
        name={name}
        radius="sm"
        variant="bordered"
        calendarProps={{
          classNames: {
            content: 'w-[290px]',
            base: 'w-[290px]',
          },
        }}
        classNames={{
          label: [
            'text-gray-900',
            'dark:text-white',
            'group-data-[invalid=true]:text-danger',
            'dark:group-data-[invalid=true]:text-danger',
          ],
          input: [
            'text-gray-900',
            'dark:text-white',
            'group-data-[invalid=true]:placeholder:text-danger',
            'group-data-[invalid=true]:text-danger',
          ],
          calendarContent: 'w-[290px]',
          calendar: 'w-[290px]',
          segment: [
            '!text-gray-900',
            'dark:!text-white',
            'group-data-[invalid=true]:!text-danger',
            'dark:group-data-[invalid=true]:!text-danger',
          ],
          inputWrapper: [
            'text-gray-900',
            'dark:!text-white',
            'bg-gray-50',
            'dark:bg-[#1e1e20]',
            'border-gray-200',
            'dark:border-default-600',
            'hover:bg-gray-100',
            'dark:hover:bg-[#1e1e20]/70',
            'group-data-[focus=true]:bg-gray-100',
            'dark:group-data-[focus=true]:bg-[#1e1e20]/50',
            'group-data-[focus=true]:border-primary',
            'dark:group-data-[focus=true]:border-primary',
            'group-data-[invalid=true]:border-danger',
            'dark:group-data-[invalid=true]:border-danger',
            '!cursor-text',
          ],
        }}
        onBlur={onBlur}
        {...props}
      />
    </motion.div>
  )
}

export default Date
